module.exports = __webpack_public_path__ + "img/region-bretagne.a3742547.webp";